/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { getStoreConfigResponse } from '@/auth/types';
import { fetchGraphQl } from '../fetch-graphql';
import { GET_STORE_CONFIG } from './graphql/getStoreConfig.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { transformStoreConfig } from '@/auth/data/transforms';
import { StoreConfigModel } from '@/auth/data/models';
import { handleFetchError } from '@/auth/lib/fetch-error';

export const getStoreConfig = async (): Promise<StoreConfigModel> => {
  return await fetchGraphQl(GET_STORE_CONFIG, {
    method: 'GET',
    cache: 'force-cache',
  })
    .then((response: getStoreConfigResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return transformStoreConfig(response);
    })
    .catch(handleNetworkError);
};
